// context/UIContext.jsx
import { createContext, useContext, useState } from "react";

const UIContext = createContext();

export const UIProvider = ({ children }) => {
  const [cartOpen, setCartOpen] = useState(false);
  // toast shape: { id, message, duration, severity }
  const [toast, setToast] = useState(null);
  const [category, setCategory] = useState(null);
  const [locationPathnames, setLocationPathnames] = useState([
    { name: "Home", path: "/", tag: "Home" },
  ]);

  const showToast = (message, opts = {}) => {
    const { duration = 3000, severity = "success" } = opts;
    setToast({ id: Date.now(), message, duration, severity });
  };

  return (
    <UIContext.Provider
      value={{
        cartOpen,
        setCartOpen,
        toast,
        setToast,
        showToast,
        category,
        setCategory,
        locationPathnames,
        setLocationPathnames,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => useContext(UIContext);
export default UIContext;
